module.exports = __webpack_public_path__ + "static/media/orange-button.f1bc7dbc.png";